import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Crate, MissingCrate } from '../../../models/Crate';
import { appendGroundPositionTypeParams, appendInspectionParams } from '../../helpers/append-query-params';
import { GroundGroupPosition } from './ground-position-group-data-source.service';

interface MissingCratesAPIResponse {
  count: number;
  crates: MissingCrate[];
}

interface ProductCountResponse {
  allProducts: {
    products: Products[];
    total: number;
  }
  target?: {
    products: Products[];
    total: number;
  }
}

interface Products {
  sku: string;
  quantity: number;
  name: string;
}

export interface ExitAPIResponse {
  count: number;
  crates: Crate[];
}

interface GetCrateByIdResponse {
  comments: any[];
  crate: Crate;
  levels: any[];
  pathToEntry: any[];
  position: GroundGroupPosition;
}

@Injectable({
  providedIn: 'root'
})
export class CratesDataSourceService {

  constructor(private http: HttpClient) { }

  getMissingCrates(params?) {
    return this.http.get<MissingCratesAPIResponse>(environment.baseUrl + '/api/v2/admin-desktop/crates/missing', { params: params }).toPromise<MissingCratesAPIResponse>();
  }

  getProductsCount(groundPositionType: string, params?) {
    const queryParams = appendGroundPositionTypeParams(params, groundPositionType);
    return this.http.get<ProductCountResponse>(environment.baseUrl + '/api/v2/admin-desktop/crates/products-count', { params: queryParams }).toPromise<ProductCountResponse>();
  }

  getPickingProductsCount(groundPositionType: string[], params: { sku: string }) {
    let httpParams = params ? { ...params } : {};
    if (groundPositionType && groundPositionType.length) {
      httpParams = { ...httpParams, groundPositionType };
    }
    return this.http.get<ProductCountResponse>(environment.baseUrl + '/api/v2/admin-desktop/crates/products-count',{ params: httpParams }).toPromise<ProductCountResponse>();
  }

  getInspectionProductsCount(params) {
    const queryParams = appendInspectionParams(params);
    return this.http.get<ProductCountResponse>(environment.baseUrl + '/api/v2/admin-desktop/crates/products-count', { params: queryParams }).toPromise<ProductCountResponse>();
  }

  getCratesFromExitPosition(params?) {
    return this.http.get<ExitAPIResponse>(environment.baseUrl + '/api/v2/admin-desktop/crates/exit', { params: params }).toPromise();
  }

  getCrateById(id: string) {
    return this.http.get<GetCrateByIdResponse>(environment.baseUrl + `/api/v2/admin-desktop/pallets/${id}`).toPromise();
  }

  getPalletsUnderAlert(crateIds: string[]) {
    const params = new URLSearchParams();
    crateIds.forEach(id => params.append('ids', id));
    return this.http.get<Crate[]>(environment.v3BaseUrl + `/api/v3/admin-desktop/pallets/under-alert?${params.toString()}`).toPromise();
  }
}
